import { FormInput, FormTextarea } from 'src/shared/components/FormComponents'
import { Column, Row } from 'src/shared/components/Semantic/all'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/shared/components/ui/card'
import { UseFormReturn } from 'react-hook-form'
import { FormData } from '../types'
import { SOURCE_PLACEHOLDER } from '../consts'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const General = ({ methods }: { methods: UseFormReturn<FormData> }) => {
  const { t } = useLocalization()
  return (
    <Card>
      <CardHeader>
        <CardTitle>General</CardTitle>
      </CardHeader>
      <CardContent>
        <Column className="gap-4">
          <Row className="gap-2">
            <FormInput
              label={
                <span>
                  Article number <span className="text-red-500">*</span>
                </span>
              }
              name="article_number"
              methods={methods}
              className="w-full"
              type="text"
            />

            <FormInput
              label={
                <span>
                  Title <span className="text-red-500">*</span>
                </span>
              }
              name="item_name"
              methods={methods}
              className="w-full"
              type="text"
            />

            <FormInput
              label={
                <span>
                  Source <span className="text-red-500">*</span>
                </span>
              }
              name="source"
              methods={methods}
              className="w-full"
              type="text"
              placeholder={SOURCE_PLACEHOLDER}
            />
          </Row>
          <Row className="gap-2 items-center">
            <FormInput
              label="Brand name"
              name="brand_name"
              methods={methods}
              className="w-full"
              type="text"
              placeholder="Enter brand name"
            />
          </Row>
          <FormTextarea
            label={
              <span>
                Description <span className="text-red-500">*</span>
              </span>
            }
            name="item_description"
            methods={methods}
            className="w-full"
          />
        </Column>
      </CardContent>
    </Card>
  )
}
